import { useCpSummary } from 'components/common-form/sidePanel/docToolbar/summary/hooks/useCpSummary';
import { CpSummaryApiConnector } from 'components/common-form/sidePanel/docToolbar/summary/mailSender/MailSenderSecondary.apiconnectors';
import type { CpSummaryMailRequest } from 'components/common-form/sidePanel/docToolbar/summary/models/cpSummaryMailRequest';
import { FormattedMessage } from 'components/shared/Intl';
import { useUserNotification } from 'hooks/useUserNotification';
import { FC } from 'react';
import { lastValueFrom } from 'rxjs';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { httpClient } from 'utils/http/httpClient';

type MailSenderOrderSecondaryProps = { tabId: string; summary?: string };

export const SummaryMailSenderOrderSecondary: FC<MailSenderOrderSecondaryProps> = ({ tabId, summary }) => {
  const cpSummaryMailRequestProps: CpSummaryMailRequest = useCpSummary(tabId);
  const notification = useUserNotification();

  const sendCpHtmlEmail = (): void => {
    const htmlRequest: CpSummaryMailRequest & { summary?: string } = {
      ...cpSummaryMailRequestProps,
      summary,
    };

    lastValueFrom(CpSummaryApiConnector(httpClient).sendMailInHtmlFormat(htmlRequest)).then(
      onMailSentWithSuccess,
      onMailSentWithError,
    );
  };

  const logAnalyticsCategory = 'Secondary market';
  const onMailSentWithError = (_: Error): void => {
    notification.error({
      title: { id: 'toast.mail' },
      content: [{ id: 'mailSentWithError' }],
      closeAutomatically: false,
    });
  };

  const onMailSentWithSuccess = (): void => {
    notification.success({ title: { id: 'toast.mail' }, content: [{ id: 'mailSentWithSuccess' }] });
  };

  const onSendToMe = (): void => {
    logAnalytics.trackEvent(logAnalyticsCategory, 'Send mail to me');
    sendCpHtmlEmail();
  };

  return (
    <button className="btn btn-xl btn-primary" onClick={onSendToMe} data-e2e="sendToMe-secondary-product-summary">
      <FormattedMessage id="sendToMe" />
    </button>
  );
};
